var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgThumbtack(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M12.324 2.438l-.515 6.609c-.047.703-.375 1.312-.985 1.687-1.078.75-1.921 1.922-2.296 3.282l-.047.234h5.437v-4.125c0-.61.469-1.125 1.125-1.125.61 0 1.125.516 1.125 1.125v4.125h5.39l-.046-.234c-.375-1.36-1.172-2.532-2.297-3.282a2.198 2.198 0 01-.984-1.687l-.516-6.61V2.25h-5.39v.188zM13.918 16.5H7.543c-.469 0-.937-.188-1.219-.563-.28-.374-.375-.843-.234-1.265l.281-1.172c.469-1.969 1.64-3.563 3.188-4.64l.375-4.36.14-2.25H8.668c-.234 0-.422-.047-.61-.14-.327-.188-.515-.563-.515-.985C7.543.515 8.012 0 8.668 0h12.75c.61 0 1.125.516 1.125 1.125 0 .422-.234.797-.562.984-.188.094-.375.141-.563.141h-1.453l.14 2.25.376 4.36c1.546 1.078 2.718 2.671 3.187 4.64l.281 1.172c.141.422.047.89-.234 1.265-.281.376-.75.563-1.219.563h-6.328v6.375A1.11 1.11 0 0115.043 24c-.656 0-1.125-.469-1.125-1.125V16.5z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgThumbtack);
export default ForwardRef;
